import {
  CrudService,
  UserService,
  AuthService,
  LeadIntentService,
  LeadTypeService,
  LeadStatusService,
  LeadNewnessService,
  InitialTouchPointService,
  SourceOfBusinessService,
  BuyingInfluenceService,
  NeedProfileManagementService,
  CustomerService,
  LeadService,
  UploadService,
  RoleService,
  ShowroomService,
  VINService,
  TradeInService,
  FinanceService,
  EcomService,
  ConfigurationService,
  VehicleService,
  LinkedinService,
  LogService,
  LeadQualityService,
  QuotationService,
  BookingService,
  PaymentService,
  OrderService,
  BankService,
  CancellationReasonService,
  DiscountDocumentTypeService,
  CashDiscountTypeService,
  PoolDiscountTypeService,
  CashDiscountService,
  PoolDiscountService,
  DiscountService,
  NetPriceCeilingService,
  VisibilityGroupService,
  DistrictService,
  GovernorateService,
  TradeInDiscountTypeService,
  TradeInDiscountService,
  DashboardService,
  NotificationService,
  OtherDiscountTypeService,
  OCRService,
  ExcessAmountAdjustmentTypeService,
  ListPriceUploadRejectReasonService,
  InvoiceService,
  MonthEndClosingService,
  ExteriorColorService,
  InteriorColorService,
  PhysicalLocationService,
  FinanceOwingBankService,
  InvoiceCancellationReasonService,
  CombinedDiscountService,
  GlobalSearchService,
  CampaignCashDiscountService,
  HolidayService,
  LeadAssigneeChangeReasonService,
  InfluencerService,
  DesignationService,
  DivisionsUnderCompany,
  VehicleSalesTargetService,
  CompanyService,
  IndustryService,
  SectorService,
  CompanySegmentService,
  LeadSourceService,
  ProductTypeInterestedService,
  AddNewRequirementService,
  RequirementService,
  ShortlistService,
  ProposalService,
  SiteVisitService,
  ProposalDocumentService,
  LegalDueDiligenceSettingService,
  LegalDueDiligenceService,
  ChangeLeadAssigneeUserReasonService,
  DocumentRejectedReasonsService,
  SearchService,
  SeniorityService,
  DepartmentService
} from "./services";

import { ApiServiceDataStore } from "./data";
import { SettingsService } from "./services/settings";
import { ReportService } from "./services/report-service";
import { TagService } from "./services/tag";
import { TiktokService } from "./services/tiktok";
import { PreBookingAvailabliltyRejectReasonService } from "./services/pre-booking-availability-reject-reasons";
import { RequestApiService } from "./services/allRequests";
import { CampaignTradeInDiscountService } from "./services/campaignTradeInDiscount";
import { CampaignNPCDiscountService } from "./services/campaignNPCDiscount";
import { CampaignPoolDiscountService } from "./services/campaignPoolDiscount";
import { CheckListService } from "./services/checklist";
import { SalesTargetService } from "./services/salesTarget";
import { BlockingReasonService } from "./services/blockingReason";
import { SatisfactionReasonService } from "./services/satisfactionReason";
import { SatisfactionLevelService } from "./services/satisfactionLevel";
import { DecisionTimeFrameService } from "./services/decisionTimeFrame";
import { ProjectService } from "./services/project";
import { PropertyService } from "./services/property";
import { TenancyService } from "./services/tenancyTracker";
// import { SiteVisitService } from "./services/sitevisit";

export class CoreApiClient {
  public crud: CrudService;
  public ecom: EcomService;
  public configuration: ConfigurationService;
  public quotation: QuotationService;
  public booking: BookingService;
  public vin: VINService;
  public tradeIn: TradeInService;
  public finance: FinanceService;
  public payment: PaymentService;
  public order: OrderService;
  public auth: AuthService;
  public report: ReportService;
  public user: UserService;
  public role: RoleService;
  public leadIntent: LeadIntentService;
  public leadType: LeadTypeService;
  public leadStatus: LeadStatusService;
  public leadNewness: LeadNewnessService;
  public decisionTimeFrame: DecisionTimeFrameService;
  public initialTouchPoint: InitialTouchPointService;
  public sourceOfBusiness: SourceOfBusinessService;
  public buyingInfluence: BuyingInfluenceService;
  public needProfileManagement: NeedProfileManagementService;
  public settings: SettingsService;
  public customer: CustomerService;
  public lead: LeadService;
  public upload: UploadService;
  public showroom: ShowroomService;
  public tiktok: TiktokService;
  public vehicle: VehicleService;
  public linkedin: LinkedinService;
  public log: LogService;
  public leadQuality: LeadQualityService;
  public bank: BankService;
  public cancellationReason: CancellationReasonService;
  public satisfactionReason: SatisfactionReasonService;
  public satisfactionLevel: SatisfactionLevelService;
  public assigneeChangeReason: LeadAssigneeChangeReasonService;
  public preBookingAvailabliltyRejectReasonService: PreBookingAvailabliltyRejectReasonService;
  public listPriceUploadRejectReasonServiceService: ListPriceUploadRejectReasonService;
  public discountDocumentType: DiscountDocumentTypeService;
  public cashDiscountType: CashDiscountTypeService;
  public poolDiscountType: PoolDiscountTypeService;
  public cashDiscount: CashDiscountService;
  public poolDiscount: PoolDiscountService;
  public discount: DiscountService;
  public netPriceCeiling: NetPriceCeilingService;
  public visibilityGroup: VisibilityGroupService;
  public governorate: GovernorateService;
  protected store: ApiServiceDataStore;
  public district: DistrictService;
  public tradeInDiscountType: TradeInDiscountTypeService;
  public vehicleSalesTarget: VehicleSalesTargetService;
  public tradeInDiscount: TradeInDiscountService;
  public tag: TagService;
  public allRequestService: RequestApiService;
  public dashboard: DashboardService;
  public notification: NotificationService;
  public otherDiscountType: OtherDiscountTypeService;
  public ocr: OCRService;
  public excessAmountAdjustmentTypeService: ExcessAmountAdjustmentTypeService;
  public invoice: InvoiceService;
  public monthEndClosingService: MonthEndClosingService;
  public exteriorColorService: ExteriorColorService;
  public interiorColorService: InteriorColorService;
  public physicalLocationService: PhysicalLocationService;
  public financeOwingBankService: FinanceOwingBankService;
  public invoiceCancellationReasonService: InvoiceCancellationReasonService;
  public combinedDiscount: CombinedDiscountService;
  public globalSearch: GlobalSearchService;
  public holiday: HolidayService;
  public campaignCashDiscount: CampaignCashDiscountService;
  public campaignTradeInDiscount: CampaignTradeInDiscountService;
  public campaignNPCDiscount: CampaignNPCDiscountService;
  public campaignPoolDiscount: CampaignPoolDiscountService;
  public checklist: CheckListService;
  public salesTarget: SalesTargetService;
  public blockingReason: BlockingReasonService;
  public influencer: InfluencerService;
  public designation: DesignationService;
  public seniority: SeniorityService;
  public department: DepartmentService;
  public divisionsUnderCompany: DivisionsUnderCompany;
  public company: CompanyService;
  public industry: IndustryService;
  public sector: SectorService;
  public companySegment: CompanySegmentService;
  public leadSource: LeadSourceService;
  public productTypeInterested: ProductTypeInterestedService;
  public project: ProjectService;
  public property: PropertyService;
  public AddNewRequirement: AddNewRequirementService;
  public requirement: RequirementService;
  public tenancy: TenancyService;
  public shortlist: ShortlistService;
  public proposal: ProposalService;
  public sitevisit: SiteVisitService;
  public proposalDocument: ProposalDocumentService;
  public legalDueDiligenceSetting: LegalDueDiligenceSettingService;
  public legalDueDiligence: LegalDueDiligenceService;
  public changeLeadAssigneeUserReasonService: ChangeLeadAssigneeUserReasonService;
  public documentRejectedReasonsService: DocumentRejectedReasonsService;
  public search: SearchService;

  constructor(apiDomain: string) {
    this.store = {
      apiDomain,
      token: undefined,
    };
    this.crud = new CrudService(this.store);
    this.project = new ProjectService(this.store);
    this.property = new PropertyService(this.store);
    this.ecom = new EcomService(this.store);
    this.configuration = new ConfigurationService(this.store);
    this.quotation = new QuotationService(this.store);
    this.booking = new BookingService(this.store);
    this.vin = new VINService(this.store);
    this.tradeIn = new TradeInService(this.store);
    this.finance = new FinanceService(this.store);
    this.payment = new PaymentService(this.store);
    this.order = new OrderService(this.store);
    this.auth = new AuthService(this.store);
    this.user = new UserService(this.store);
    this.role = new RoleService(this.store);
    this.leadIntent = new LeadIntentService(this.store);
    this.leadType = new LeadTypeService(this.store);
    this.leadStatus = new LeadStatusService(this.store);
    this.leadNewness = new LeadNewnessService(this.store);
    this.decisionTimeFrame = new DecisionTimeFrameService(this.store);
    this.initialTouchPoint = new InitialTouchPointService(this.store);
    this.sourceOfBusiness = new SourceOfBusinessService(this.store);
    this.buyingInfluence = new BuyingInfluenceService(this.store);
    this.needProfileManagement = new NeedProfileManagementService(this.store);
    this.settings = new SettingsService(this.store);
    this.customer = new CustomerService(this.store);
    this.lead = new LeadService(this.store);
    this.upload = new UploadService(this.store);
    this.showroom = new ShowroomService(this.store);
    this.vehicle = new VehicleService(this.store);
    this.linkedin = new LinkedinService(this.store);
    this.log = new LogService(this.store);
    this.leadQuality = new LeadQualityService(this.store);
    this.bank = new BankService(this.store);
    this.report = new ReportService(this.store);
    this.cancellationReason = new CancellationReasonService(this.store);
    this.satisfactionReason = new SatisfactionReasonService(this.store);
    this.satisfactionLevel = new SatisfactionLevelService(this.store);
    this.preBookingAvailabliltyRejectReasonService = new PreBookingAvailabliltyRejectReasonService(
      this.store
    );
    this.listPriceUploadRejectReasonServiceService = new ListPriceUploadRejectReasonService(
      this.store
    );
    this.discountDocumentType = new DiscountDocumentTypeService(this.store);
    this.cashDiscountType = new CashDiscountTypeService(this.store);
    this.poolDiscountType = new PoolDiscountTypeService(this.store);
    this.cashDiscount = new CashDiscountService(this.store);
    this.poolDiscount = new PoolDiscountService(this.store);
    this.discount = new DiscountService(this.store);
    this.netPriceCeiling = new NetPriceCeilingService(this.store);
    this.visibilityGroup = new VisibilityGroupService(this.store);
    this.district = new DistrictService(this.store);
    this.governorate = new GovernorateService(this.store);
    this.tradeInDiscount = new TradeInDiscountService(this.store);
    this.tradeInDiscountType = new TradeInDiscountTypeService(this.store);
    this.vehicleSalesTarget = new VehicleSalesTargetService(this.store);
    this.tag = new TagService(this.store);
    this.allRequestService = new RequestApiService(this.store);
    this.dashboard = new DashboardService(this.store);
    this.notification = new NotificationService(this.store);
    this.tiktok = new TiktokService(this.store);
    this.otherDiscountType = new OtherDiscountTypeService(this.store);
    this.ocr = new OCRService(this.store);
    this.assigneeChangeReason = new LeadAssigneeChangeReasonService(this.store);
    this.excessAmountAdjustmentTypeService = new ExcessAmountAdjustmentTypeService(
      this.store
    );
    this.invoice = new InvoiceService(this.store);
    this.monthEndClosingService = new MonthEndClosingService(this.store);
    this.exteriorColorService = new ExteriorColorService(this.store);
    this.interiorColorService = new InteriorColorService(this.store);
    this.physicalLocationService = new PhysicalLocationService(this.store);
    this.financeOwingBankService = new FinanceOwingBankService(this.store);
    this.invoiceCancellationReasonService = new InvoiceCancellationReasonService(
      this.store
    );
    this.combinedDiscount = new CombinedDiscountService(this.store);
    this.globalSearch = new GlobalSearchService(this.store);
    this.holiday = new HolidayService(this.store);
    this.campaignCashDiscount = new CampaignCashDiscountService(this.store);
    this.campaignTradeInDiscount = new CampaignTradeInDiscountService(
      this.store
    );
    this.campaignNPCDiscount = new CampaignNPCDiscountService(this.store);
    this.campaignPoolDiscount = new CampaignPoolDiscountService(this.store);
    this.checklist = new CheckListService(this.store);
    this.salesTarget = new SalesTargetService(this.store);
    this.blockingReason = new BlockingReasonService(this.store);
    this.designation = new DesignationService(this.store);
    this.seniority = new SeniorityService(this.store);
    this.department = new DepartmentService(this.store);
    this.divisionsUnderCompany = new DivisionsUnderCompany(this.store);
    this.influencer = new InfluencerService(this.store);
    this.company = new CompanyService(this.store);
    this.industry = new IndustryService(this.store);
    this.sector = new SectorService(this.store);
    this.companySegment = new CompanySegmentService(this.store);
    this.leadSource = new LeadSourceService(this.store);
    this.productTypeInterested = new ProductTypeInterestedService(this.store);
    this.AddNewRequirement = new AddNewRequirementService(this.store);
    this.requirement = new RequirementService(this.store);
    this.tenancy = new TenancyService(this.store);
    this.shortlist = new ShortlistService(this.store);
    this.proposal = new ProposalService(this.store);
    this.sitevisit = new SiteVisitService(this.store);
    this.proposalDocument = new ProposalDocumentService(this.store);
    this.legalDueDiligenceSetting = new LegalDueDiligenceSettingService(
      this.store
    );
    this.legalDueDiligence = new LegalDueDiligenceService(this.store);
    this.changeLeadAssigneeUserReasonService = new ChangeLeadAssigneeUserReasonService(
      this.store
    );
    this.documentRejectedReasonsService = new DocumentRejectedReasonsService(
      this.store
    );
    this.search = new SearchService(this.store);
  }

  public setToken(token?: string) {
    this.store.token = token;
  }
}
